export const hirerSpacePageRegex = /^\/location\/([^/]+)\/space\/([^/]+)$/;
export const hirerLocationPageRegex = /^\/location\/([^/]+)$/;
